import { createApi } from "@reduxjs/toolkit/dist/query/react/index";
import { baseQueryWithTokenExpirationCheck } from "./config/query.config";
import { TAG_IDS, TAG_TYPES } from "./config/apiTags";

// Types
export interface SupportedTradeTime {
  tradeTime: number;
  enabled: boolean;
  payoutRatio: number;
}

export type TradePreset = {
  label: string;
  time: string;
  tradeTimes: SupportedTradeTime[];
};

export interface Game {
  id: string;
  title: string;
  market: string;
  supportedTradeTimes: TradePreset[];
  [key: string]: any;
}

export interface ToggleTradeTimeRequest {
  gameId: string;
  tradeTime: number;
  enabled: boolean;
  tradingPeriodId: string;
}

export interface AuditLogRequest {
  asset: string;
  timeframe: number;
  newState: boolean;
  timestamp: string;
  userId: string;
}

export interface TradingPeriod {
  id: string;
  label: string;
  start: string;
  end: string;
}

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: baseQueryWithTokenExpirationCheck,
  tagTypes: [...TAG_TYPES, ...TAG_IDS],
  endpoints: (builder) => ({
    getAllGames: builder.query<
      {
        games: Game[];
        currentTradingPeriod: TradingPeriod;
        tradingPeriods: TradingPeriod[];
      },
      void
    >({
      query: () => ({
        url: "/api/games/all-games",
        method: "GET",
      }),
      providesTags: ["GAMES"],
    }),
    toggleTradeTime: builder.mutation<any, ToggleTradeTimeRequest>({
      query: (data) => ({
        url: `/api/games/${data.gameId}/trade-time`,
        method: "PUT",
        body: {
          tradeTime: data.tradeTime,
          enabled: data.enabled,
          tradingPeriodId: data.tradingPeriodId,
        },
      }),
      invalidatesTags: ["GAMES"],
    }),
    auditLog: builder.mutation<any, AuditLogRequest>({
      query: (data) => ({
        url: "/api/audit-log",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAllGamesQuery,
  useToggleTradeTimeMutation,
  useAuditLogMutation,
} = baseApi;
